import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=6fb5443e&scoped=true&"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=6fb5443e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5443e",
  null
  
)

export default component.exports